import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../shared/components/FormElements/Button";
// Reuse the card chrome (width, edges, shadow + responsive breakpoints) from
// PerformanceComparison so both cards stay visually identical.
import "./PerformanceComparison.css";

const Subscribe = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className="pc-wrapper">
        <div className="pc-card" style={{ textAlign: "center" }}>
          <p style={{ color: "#888", fontSize: 13, lineHeight: 1.6, margin: "0 0 20px" }}>
            Receive trading signals every trading day on a selected set of titles via Email. Premium: Connect your broker account for automatic trading.
          </p>
          <Button onClick={() => setShowModal(true)}>
            Subscribe to the Signal
          </Button>
        </div>
      </div>

      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#0d0d0f",
              border: "1px solid #1a1a20",
              borderRadius: 16,
              padding: "32px",
              maxWidth: 440,
              width: "90%",
              boxShadow: "0 40px 80px rgba(0,0,0,0.8)",
            }}
          >
            <h3 style={{
              color: "#ccc",
              fontSize: 16,
              fontWeight: 600,
              margin: "0 0 16px",
            }}>
              Subscribe
            </h3>
            <p style={{ color: "#666", fontSize: 12, lineHeight: 1.6, margin: "0 0 24px" }}>
              Create an account, then subscribe to Signal Access (CHF 15/month) to receive
              daily trade signals, curated trade opportunities, and portfolio performance
              reports by email.
            </p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <Button inverse onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button onClick={() => navigate("/auth?mode=signup")}>
                Create account
              </Button>
            </div>
            <p style={{ color: "#666", fontSize: 12, textAlign: "center", margin: "20px 0 0" }}>
              Already have an account?{" "}
              <button
                type="button"
                onClick={() => navigate("/auth")}
                style={{ background: "none", border: "none", padding: 0, color: "#ccc", fontSize: 12, textDecoration: "underline", cursor: "pointer" }}
              >
                Log in
              </button>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default Subscribe;
